import queryString from 'query-string';
import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import * as Error404Actions from 'rebook/apps/base/actions/Error404Actions';
import {
  SEARCH_SEARCH_BOOKSETS_SET_DATA,
  SEARCH_SEARCH_BOOKSETS_RESET_DATA,
} from 'rebook/apps/search/constants';


export function fetchInitialData(location = {}) {
  return async(dispatch, getState) => {
    const { ssr, searchBooksets: currentState } = getState();
    const limit = 10;
    const pageNumber = get(ssr, 'query.page', 1);

    let newState = {
      pageNumber,
    };

    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
        isLoading: false,
        lastPageNumber: Math.ceil(location.state.booksetsCount / limit),
      };
    }

    // set partial state (it could probably be the data obtained from router)
    dispatch(setData(newState));

    if (!newState.booksetList || (currentState.pageNumber !== pageNumber && newState.query !== location.state.query)) {
      await dispatch(fetchBooksets(pageNumber));
    }

    if (newState.booksetList) {
      dispatch(fetchBooksetBooks(newState.booksetList));
    }
  };
}

export function fetchBooksets(pageNumber = 1) {
  return async(dispatch, getState) => {
    const { ssr, searchBooksets: currentState } = getState();
    const limit = 10;

    const query = get(ssr, 'query.q', currentState.query);

    if (!query) {
      dispatch(setData({ isLoading: false }));
      return;
    }

    dispatch(setData({ isLoading: true }));

    let queryParams = {
      q: query,
      limit,
      offset: (pageNumber - 1) * limit,
    };

    const qs = queryString.stringify(queryParams);
    const url = `/api/search/booksets/?${qs}`;

    const booksetList = await fetchQuery(url, { apiVersion: 5, headers: ssr.headers })
      .then(({ data }) => {
        const lastPageNumber = Math.ceil(data.meta.total_count / limit);
        dispatch(setData({
          booksetList: data.objects,
          booksetsCount: data.meta.total_count,
          query,
          pageNumber,
          lastPageNumber,
          isLoading: false,
        }));
        return data.objects;
      })
      .catch(({ data, resp, error }) => {
        if (resp.status === 404) {
          dispatch(Error404Actions.show());
        }
        else {
          Raven.captureMessage('failed to load bookset list due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
              error,
            },
          });
          throw new Error('failed to load bookset list detail due to server error');
        }
      });

    dispatch(fetchBooksetBooks(booksetList));
  };
}

function fetchBooksetBooks(booksetList) {
  return async(dispatch, getState) => {
    booksetList.map((bookset, i) => {
      const { ssr } = getState();
      const limit = 10;
      const url = `/api/booksets/${bookset.id}/books/?limit=${limit}`;

      fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
        .then(({ data }) => {
          booksetList[i].books = data.objects,
          dispatch(setData({
            booksetList,
          }));
        })
        .catch(({ data, resp, error }) => {
          if (resp.status === 404) {
            dispatch(Error404Actions.show());
          }
          else {
            Raven.captureMessage('failed to load bookset books due to server error', {
              level: 'error',
              extra: {
                status: resp.status,
                response: data,
                error,
              },
            });
            throw new Error('failed to load bookset books detail due to server error');
          }
        });
    });
  };
}

function setSeoMeta() {
  return (dispatch, getState) => {
    const { ssr, searchBooksets: currentState } = getState();
    const booksetName = get(ssr, 'ssr.query.q', currentState.query);
    const title = `Все подборки по запросу «${booksetName}»`;

    dispatch(SeoActions.setData({
      title,
    }));
  };
}

export function setData(payload) {
  return (dispatch) => {
    const { booksetList } = payload;
    dispatch({
      type: SEARCH_SEARCH_BOOKSETS_SET_DATA,
      payload,
    });
    if (booksetList) {
      dispatch(setSeoMeta());
    }
  };
}

export function resetData() {
  return (dispatch) => {
    dispatch(SeoActions.resetData());
    dispatch({
      type: SEARCH_SEARCH_BOOKSETS_RESET_DATA,
    });
  };
}
